import React, { useState, useEffect, useRef, useCallback } from 'react';
import Button from 'react-bootstrap/Button';
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import PageHeading from '../../components/pageHeading/PageHeading'
import '../../jobHistory.scss'
import { DownArrow } from '../../components/Icons';
import Paginate from '../../components/paginate/Paginate';
import { cancelUserJob, fetchProviderJobInvoice, fetchUserJobs,markJobComplete ,checkProviderStartJob} from '../../services/auth.service';
import JobContainer from './JobContainer';
import Search from '../../components/search/Search';
import { useDispatch, useSelector } from 'react-redux';
import { setLoader } from '../../slice/commonSlice';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { toast_error, toast_success } from '../../config/Constant';
import RaiseDispute from '../../modals/raiseDispute/RaiseDispute';
import OTP from '../../modals/userverifiyJobOtp/OTP';
import ReviewModal from '../../modals/review/ReviewModal';
import { TwoUsers } from 'react-iconly';
import TipModal from '../../modals/tip/TipModal';
import PaymentModal from '../../modals/payment/PaymentModal';
import { selectUser } from '../../slice/authSlice';
import { base64toBlob } from '../../utils/common';
import moment from 'moment';


const JobHistoryUser = () => {
  const [activeTab, setActiveTab] = useState('upcoming');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isJobRequest, setJobRequest]= useState(false);
  const [jobRequestCount, setJobRequestCount] = useState(null);
  const [jobList, setJobList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [disputeJob, setDisputeJob] = useState({});
  const [selectedJob, setSelectedJob] = useState({});
  const [disputeModal, setDisputeModal] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [reviewModal, setReviewModal] = useState(false);
  const [tipModal, setTipModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const listRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleTabClick = (index) => {
    setActiveTab(index);
    if (dropdownOpen) {
      setDropdownOpen(false);
    }
  };

  const user = useSelector(selectUser);
  let roles = user?.userType;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (listRef.current && !listRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(()=>{
    setSearchTerm('');
    setCurrentPage(1);
    fetchJoblistUser(1);
  }, [activeTab])

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleJobRequest = ()=>{
    navigate('/consumer/jobrequest')
    // setJobRequest(true);
    // setActiveTab('Incoming')
  }

  const handleMarkComplete = async (id) =>{
    let payload = {
      "jobId": id,
      "jobStatus": "CO"
    }
    await dispatch(setLoader(true));
    try {
      const response = await markJobComplete(payload);
      toast.success(response?.data?.message, toast_success)
      await dispatch(setLoader(false));
      fetchJoblistUser(currentPage, searchTerm);
    } catch (error) {
      toast.success(error?.data?.message, toast_error)
      await dispatch(setLoader(false));
      console.error("Error fetching profile data:", error);
    }
  }

  const fetchJoblistUser = async (page, term = '') => {
    let payload = {
      "pageNumber" : page,
      "jobStatus" : jobStatus(), // UPCOMING, CO, CN, PAST
      "search" : term
    }
    await dispatch(setLoader(true));
    try {
      const response = await fetchUserJobs(payload);
      await dispatch(setLoader(false));
      setJobRequestCount(response?.data?.jobRequestCount)
      setJobList(response.data?.jobs)
      setTotalPages(response.data?.totalPages)
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching profile data:", error);
    }
  }

  const cancelRequest = async (id, providerId, paymentProfileId) => {
    
    const currentTimestampInSeconds = moment().unix();
    let payload = {
      "jobId": id,
      "timeStamp": currentTimestampInSeconds,
      "providerId": providerId,
      "customerProfileId": user?.userCustomerProfileId,
      "paymentProfileId": paymentProfileId,
      "jobType": "ON"
    }
    await dispatch(setLoader(true));
    try {

      const checkResponse = await checkProviderStartJob(id);

      if (checkResponse && checkResponse.isStartTimePassed) {
        toast.error("The job's start time has already passed. It cannot be canceled.", toast_error);
        await dispatch(setLoader(false));
        return; // Exit the function
      }

      if (checkResponse && checkResponse.providerStartJob) {
        // If providerStartJob is true, do not cancel
        toast.error("Cannot cancel job : Job has already started.", toast_error);
        await dispatch(setLoader(false));
        return; // Exit the function
      }

      // alert("Job has canceled")

      const response = await cancelUserJob(payload);
      await dispatch(setLoader(false));
      if(response.status){
        toast.success(response?.data?.message, toast_success)
        fetchJoblistUser(currentPage, searchTerm)
      }
    } catch (error) {
      toast.success(error?.data?.message, toast_error)
      await dispatch(setLoader(false));
      console.error("Error fetching profile data:", error);
    }
  }

  const jobStatus = () =>{
    if(activeTab === 'upcoming'){
      return 'UPCOMING'
    } else if(activeTab === 'completed'){
      return 'CO'
    } else if(activeTab === 'cancelled'){
      return 'CN'
    } else if(activeTab === 'past'){
      return 'PAST'
    }
  }

  const handlePageChange = (page) =>{
    setCurrentPage(page);
    fetchJoblistUser(page, searchTerm)
  }

  const handleOtpModal = (id) =>{
    setJobId(id);
    setOtpModal(true);
  }

  const handleReviewModal = (job) =>{
    setSelectedJob(job);
    setReviewModal(true);
  }

  const handleDispute = (status, job) => {
    setDisputeJob(job);
    setDisputeModal(status);
  }

  const handleDisputeSuccess = () =>{
    fetchJoblistUser(currentPage, searchTerm)
  }

  const handleReviewSuccess = () =>{
    fetchJoblistUser(currentPage, searchTerm)
  }

  const handleSearch = useCallback((term) => {
    setSearchTerm(term);
    setCurrentPage(1);
    fetchJoblistUser(1, term);
  }, [setSearchTerm]);

  const handleTipModal = (job) =>{
    setSelectedJob(job);
    setTipModal(true);
  }

  const handleSuccessTip = () =>{
    fetchJoblistUser(currentPage, searchTerm)
  }

  const handlePaymentModal = (job) =>{
    setSelectedJob(job);
    setPaymentModal(true);
  }

  //function to generate jonb invoice pdf
  const handleInvoice = async (job) => {
    try {
      const payload = {
        jobId: job?._id,
        userType: roles,
      };
      await dispatch(setLoader(true));
      const response = await fetchProviderJobInvoice(payload);
      if (response?.data?.status) {
        const pdfData = response.data.data; // Base64 encoded PDF data
        const blob = base64toBlob(pdfData, 'application/pdf');  
        const link = document.createElement("a");
        const blobUrl = window.URL.createObjectURL(blob);
        link.href = blobUrl;

        var currentDate = new Date();
        var year = currentDate.getFullYear();
        var month = ("0" + (currentDate.getMonth() + 1)).slice(-2); // Adding 1 because months are zero-based
        var day = ("0" + currentDate.getDate()).slice(-2);

        // Create the file name with the current date
        var fileName = "jobsinvoice_" + year + "_" + month + "_" + day + ".pdf";

        // Set the download attribute of the link
        link.download = fileName;
        // link.download = 'transactions-export.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        await dispatch(setLoader(false));
      } else {
        toast.error(response?.data?.message);
        await dispatch(setLoader(false));
      }
    } catch (error) {
      console.log("error", error);
      await dispatch(setLoader(false));
    }
  };

  return (
    <>
      <Header />
      <PageHeading title="Jobs" />
      <div className='main-container'>
        <div className='container-wrap'>
          <div className='job-history-header'>
            <div className='job-search'>
              <Search setSearchTerm={setSearchTerm} searchTerm={searchTerm}  onSearch={handleSearch} />
              <div className='job-request-wrap'>
                <Button variant='outline-primary' onClick={()=>handleJobRequest()}>Job Request ({jobRequestCount || 0})</Button>
              </div>
            </div>
            {isJobRequest ? <>
              <div className='job-nav'>
              <ul>
                <li className={`${activeTab === 'Incoming' ? 'active' : ''}`} onClick={() => handleTabClick('Incoming')}>Incoming</li>
                <li className={`${activeTab === "Outgoing" ? 'active' : ''}`} onClick={() => handleTabClick('Outgoing')}>Outgoing</li>
          
              </ul>
            </div>
            <div className=' '>
              <div className="job-nav-header" onClick={toggleDropdown}>
                <div>{activeTab}</div> <div><DownArrow /></div>
              </div>
              {dropdownOpen && (
                <ul ref={listRef}>

                  <li className={`${activeTab === 'upcoming' ? 'active' : ''}`} onClick={() => handleTabClick('upcoming')}>Ongoing</li>
                  <li className={`${activeTab === 'completed' ? 'active' : ''}`} onClick={() => handleTabClick('completed')}>Completed</li>
                  <li className={`${activeTab === 'cancelled' ? 'active' : ''}`} onClick={() => handleTabClick('cancelled')}>Cancelled</li>
                  {/* <li className={`${activeTab === 'past' ? 'active' : ''}`} onClick={() => handleTabClick('past')}>Past</li> */}
                </ul>
              )}
            </div>
            
            </>
             :
             <>
             
             <div className='job-nav'>
              <ul>
                <li className={`${activeTab === 'upcoming' ? 'active' : ''}`} onClick={() => handleTabClick('upcoming')}>Ongoing</li>
                <li className={`${activeTab === 'completed' ? 'active' : ''}`} onClick={() => handleTabClick('completed')}>Completed</li>
                <li className={`${activeTab === 'cancelled' ? 'active' : ''}`} onClick={() => handleTabClick('cancelled')}>Cancelled</li>
                {/* <li className={`${activeTab === 'past' ? 'active' : ''}`} onClick={() => handleTabClick('past')}>Past</li> */}
              </ul>
            </div>
            <div className='job-nav-dropdown'>
              <div className="job-nav-header" onClick={toggleDropdown}>
                <div>{activeTab}</div> <div><DownArrow /></div>
              </div>
              {dropdownOpen && (
                <ul ref={listRef}>
                  <li className={`${activeTab === 'upcoming' ? 'active' : ''}`} onClick={() => handleTabClick('upcoming')}>Ongoing</li>
                  <li className={`${activeTab === 'completed' ? 'active' : ''}`} onClick={() => handleTabClick('completed')}>Completed</li>
                  <li className={`${activeTab === 'cancelled' ? 'active' : ''}`} onClick={() => handleTabClick('cancelled')}>Cancelled</li>
                  {/* <li className={`${activeTab === 'past' ? 'active' : ''}`} onClick={() => handleTabClick('past')}>Past</li> */}
                </ul>
              )}
            </div>
             </>
          }
           
          </div>


          <div className='job-tab-content-wrap'>
            {activeTab === 'upcoming' && <JobContainer handleMarkComplete={handleOtpModal} type = 'upcoming' list = {jobList} handlePayment={handlePaymentModal} cancelRequest={cancelRequest}/>}
            {activeTab === 'completed' && <JobContainer handleTip={handleTipModal} handleDispute={handleDispute} handleReview={handleReviewModal} type = 'completed' list = {jobList} handleInvoice={handleInvoice}/>}
            {activeTab === 'cancelled' && <JobContainer type = 'cancelled' list = {jobList} />}
            {/* {activeTab === 'past' && <JobContainer type = 'past' list = {jobList} />} */}
          </div>
          { jobList?.length > 0 && 
          <Paginate totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange} 
            /> 
          }
        </div>
      </div>
      <Footer />
      { disputeModal ? <RaiseDispute disputeJob={disputeJob} handleDisputeSuccess={handleDisputeSuccess} setDisputeModal={setDisputeModal} disputeModal={disputeModal} /> : null }
      { reviewModal ? <ReviewModal job={selectedJob} handleReviewSuccess={handleReviewSuccess} setReviewModal={setReviewModal} reviewModal={reviewModal} /> : null }
      { otpModal ? <OTP otpModal={otpModal} jobId={jobId} handleMarkComplete={handleMarkComplete} setOtpModal={setOtpModal} /> : null}
      { tipModal ? <TipModal tipModal={tipModal} setTipModal={setTipModal} job={selectedJob} handleSuccessTip={handleSuccessTip} /> : null }
      { paymentModal ? <PaymentModal paymentModal={paymentModal} setPaymentModal={setPaymentModal} job={selectedJob} handleSuccessTip={handleSuccessTip} /> : null }

    </>

  )
}

export default JobHistoryUser